import Vue from 'vue'
import tagview from './tagview'
import topbar from './topbar'
import footer from './footer'

// Component
Vue.component('app-tagview', tagview)
Vue.component('app-topbar', topbar)
Vue.component('app-footer', footer)
